import React from 'react';
import ReactDOM from 'react-dom'
import axios from 'axios'
import { useFormik } from 'formik';
import './styles/form.css'
import * as Yup from 'yup'
import { loadProgressBar } from 'x-axios-progress-bar'
import 'x-axios-progress-bar/dist/nprogress.css'
import TreeForm from './TreeForm'
import ObserverForm from './ObserverForm'
import ObservationsForm from './ObservationsForm'

//const port=process.env.REACT_APP_PORT2
const baseUrl= process.env.REACT_APP_HOST

const MasterForm=()=>{
    loadProgressBar()
    const formik = useFormik({
      initialValues: {
          email:'',
          password: '',
          formType:'',
          newUserFirstName:'',
          newUserLastName:'',
          newUserEmail:'',
          newUserPassword:'',
          
      },
      validationSchema: Yup.object({
            email: Yup.string().email().max(30, 'Please enter an email address.').required('Email is Required'),
            password: Yup.string().max(30, 'Please enter a password.').required('Password is Required'),
            formType: Yup.string().oneOf(['tree','observer','observations']).required('Form Type is Required'),

            
      }),
      onSubmit: values => {
        
        axios.get(baseUrl+'verifyCredentials',{params:{Email:formik.values.email.toString(),Password:formik.values.password.toString()}}).then(res=>{
            if(!res.data){
                    alert("\t\tCredentials not found.\n\nPlease type valid email and password.")
                    ReactDOM.render(<div id="Trees"></div>,document.getElementById("Trees"))
                    document.getElementById("masterFormInstruction").hidden=true;
            }
            else{
                if(formik.values.formType==='tree'){
                    ReactDOM.render(<TreeForm/>,document.getElementById("Trees"))
                }
                else if(formik.values.formType==='observer'){
                    ReactDOM.render(<ObserverForm/>,document.getElementById("Trees"))
                }
		else if(formik.values.formType==='observations'){
                    ReactDOM.render(<ObservationsForm/>,document.getElementById("Trees"))
                }
                document.getElementById("masterFormInstruction").hidden=false;
            }
            
        })
        
      },
    })
        return(
            <div class="App">
            <div class="TreeObservationsForm">
                <img class="logo" src="Logo_square.jpeg" alt="" ></img> 
                <div align="center">
                 <form onSubmit={formik.handleSubmit}>
                <legend>
                    Master Form
                </legend>
                <table class="BasicInfoTable">
                    <tr>
                        <td>
                        <label class="BasicInfoLabel">Email</label>
                        </td>
                        <td class="BasicInput" >
                            <input type="text"
                             name="email"
                             onChange={formik.handleChange}
                             value={formik.values.email}
                            ></input>
                        </td>
                    </tr>
                    {formik.touched.email && formik.errors.email ? (<div class="Error">{formik.errors.email}</div>) : null}

                    <tr>
                        <td>
                            <label class="BasicInfoLabel">Password</label>
                        </td>
                        <td class="BasicInput" >
                            <input type="password"
                             name="password"
                             onChange={formik.handleChange}
                             value={formik.values.password}
                            ></input>
                        </td>
                    </tr>

                    {formik.touched.password && formik.errors.password ? (<div class="Error">{formik.errors.password}</div>) : null}

                    <tr>
                        <td>
                            <label class="BasicInfoLabel">Form Type</label>
                        </td>
                        <td>
                            <select name="formType" onChange={formik.handleChange}>
                                <option value={null}>Select type...</option>
                                <option value="tree">Manage Trees</option>
                                <option value="observer">Manage Observers</option>
		     		<option value="observations">Manage Observations</option>
                            </select>
                        </td>

                    </tr>
                    {formik.touched.formType && formik.errors.formType ? (<div class="Error">{formik.errors.formType}</div>) : null}

                </table>
                <div class="submitForm">
                    <button class="btn btn-success" type="submit">
                            Submit
                    </button>
                    <div class="explanation">
                    <label class="masterFormInstruction" id="masterFormInstruction" hidden>  Use the form below to add/update/modify entries</label>
					</div>
                </div>
                </form>

                <div id="Trees"></div>
                <div id="Observers"></div>
            </div>
            </div>
            </div>
        )
}
 
export default MasterForm;
